import type { SearchScenarioId } from "owa-search-store";
import { action } from "satcheljs";

/**
 * This action is dispatched when the user takes an action that should end
 * a search session.
 */
export interface END_SEARCH_SESSIONActionMessage {
    scenarioId: SearchScenarioId;
    actionSource: string;
}
export const endSearchSession: (scenarioId: SearchScenarioId, actionSource: string) => END_SEARCH_SESSIONActionMessage = action("END_SEARCH_SESSION", (scenarioId: SearchScenarioId, actionSource: string): END_SEARCH_SESSIONActionMessage => ({
    scenarioId,
    actionSource,
}));
